/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PaymentCheckView } from '../models/PaymentCheckView';
import type { PaymentCreateRequest } from '../models/PaymentCreateRequest';
import type { PaymentView } from '../models/PaymentView';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class PaymentService {
    /**
     * Create payment for product subscription
     * @param requestBody
     * @returns PaymentView Payment created successfully
     * @throws ApiError
     */
    public static postAppPaymentCreate(
        requestBody: PaymentCreateRequest,
    ): CancelablePromise<PaymentView> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v2/api/payment',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Check payment status
     * @param paymentId
     * @returns PaymentCheckView Payment status
     * @throws ApiError
     */
    public static getAppPaymentCheck(
        paymentId: string,
    ): CancelablePromise<PaymentCheckView> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v2/api/payment/{paymentId}/check',
            path: {
                'paymentId': paymentId,
            },
            errors: {
                400: `Error`,
            },
        });
    }
}
